import styled from 'styled-components';

interface PopOverButtonProps {
  isActive: boolean;
}

export const PopOverButton = styled.div<PopOverButtonProps>`
  cursor: pointer;
  background: #f7f7f7;
  padding: 2px 6px;
  border-radius: 4px;
  width: fit-content;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  span {
    color: ${({ isActive }) => (isActive ? '#00ab6b' : '#858585')};
    font-size: 12px;
    padding: 0;
    margin: 0;
    line-height: normal;
  }
`;

export const PopOverContent = styled.div`
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 4px;
  min-width: 250px;
`;

export const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  padding: 12px;
  border-bottom: 1px solid #ededed;

  span {
    font-size: 13px;
    font-weight: bold;
  }
  
  img {
    cursor: pointer;
  }
`;

export const HeaderTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
`;

export const ContentCard = styled.div`
  padding: 12px;
`;
